<div class="related-panel">
  <p class="related-empty" *ngIf="!customerId">
    Salve o cliente para listar os acessos.
  </p>

  <ng-container *ngIf="customerId">
    <p class="related-empty" *ngIf="loading">Carregando acessos...</p>
    <p class="related-empty" *ngIf="!loading && rows.length === 0">
      Nenhum acesso encontrado para este cliente.
    </p>

    <table mat-table [dataSource]="rows" *ngIf="!loading && rows.length" class="related-table">
      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef>E-MAIL</th>
        <td mat-cell *matCellDef="let row">{{ row.email }}</td>
      </ng-container>
      <ng-container matColumnDef="system">
        <th mat-header-cell *matHeaderCellDef>SISTEMA</th>
        <td mat-cell *matCellDef="let row">{{ row.system }}</td>
      </ng-container>
      <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef>TIPO</th>
        <td mat-cell *matCellDef="let row">{{ row.type }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="open(row)"></tr>
    </table>
  </ng-container>
</div>
